import React from 'react';
import Landing from '../components/Landing';
import Skills from '../components/Skills';
import FrontEnd from '../components/FrontEnd';
import FullStack from '../components/FullStack';
//import Contact from '../components/Contact';
import ScrollTop from '../components/utils/ScrollTop';
import Nav from '../components/Nav';

const Main = ({ theme, toggleTheme }) => {
  return (
    <div className='y-scroll-snap'>
      <Nav theme={theme} toggleTheme={toggleTheme} />
      <Landing />
      <Skills />
      <FullStack />
      <FrontEnd />
      {/* <Contact /> */}
      <ScrollTop />
    </div>
  );
};

export default Main;
